import HeroImage from '@resources/highlighted-apartment.jpg?format=webp&quality=75&w=1600;1200;1000;767;500&as=srcset&imagetools';
import Container from '../Grid/Container';
import Row from '../Grid/Row';
import Column from '../Grid/Column';
import { Link } from '@inertiajs/react';
import { Icon } from '@iconify/react/dist/iconify.js';

export const HighlightedApartment = () => {
    return (
        <section id={'highlighted-apartment'} className="lg:py-18 py-10 relative overflow-hidden">
            <div className='bg-secondary w-full h-[70%] absolute left-0 z-0 top-1/2 -translate-y-1/2 hidden lg:block' />
            <Container className='z-10 relative hidden lg:block'>
                <div className="hidden lg:block z-30 lg:absolute lg:top-1/2 lg:-translate-y-1/2 left-3 maxMd:left-4 glass-style p-8 md:p-10 xl:p-14 max-w-[34rem] w-auto rounded-lg mb-6 lg:mb-0">
                    <h2 className='text-primary text-h3 leading-h3 uppercase font-extrabold mb-8'>Odwiedź mieszkanie pokazowe</h2>
                    <p className='text-p leading-p tracking-[0.45px] text-text'>Zobacz standard, układ i jakość wykonania przed decyzją.</p>
                    <div className="flex flex-row gap-x-8 my-8 items-center">
                        <Icon icon={`hugeicons:city-01`} width={52} height={52} />
                        <div className='text-black'>
                            <p className='text-sm uppercase font-extrabold tracking-[0.35px]'>BIURO SPRZEDAŻY</p>
                            <p className='text-p leading-p tracking-[0.45px] text-text'>ul. Kusocińskiego 5/2</p>
                        </div>
                    </div>
                    <div className="flex flex-row gap-x-5">
                        <a
                            href="/mieszkania/szczegoly/32a293ec-3582-ee11-8179-000d3a2e47bc#contact-form"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href =
                                    "/mieszkania/szczegoly/32a293ec-3582-ee11-8179-000d3a2e47bc#contact-form";
                            }}
                            className="bg-primary button-primary max-w-fit"
                        >
                            UMÓW WIZYTĘ
                        </a>
                        <Link href={'/mieszkania/szczegoly/32a293ec-3582-ee11-8179-000d3a2e47bc'} className='border-primary border-[2px] button-outline max-w-fit'>
                            ZOBACZ SZCZEGÓŁY
                        </Link>
                    </div>
                </div>
                <Row>
                    <Column xl={10} lg={10} className='ml-auto'>
                        <img srcSet={HeroImage} alt="Hero" className="w-full h-full object-cover px-6" loading='lazy' />
                    </Column>
                </Row>
            </Container>
            <div className='lg:hidden'>
                <img srcSet={HeroImage} alt="Hero" className="w-full h-auto object-cover" loading='lazy' />
                <div className="glass-style w-full px-4 pt-14 pb-8">
                    <h2 className='text-primary text-h3 leading-h3 uppercase font-extrabold mb-6'>Odwiedź nasze mieszkanie pokazowe, zakochaj się w szczegółach</h2>
                    <p className='text-p leading-p tracking-[0.45px] text-text'>Sprawdź układ, poczuj przestrzeń i przekonaj się na własne oczy, jak wygląda życie w mieszkaniu wykończonym pod klucz. To gotowe miejsce, do którego możesz się wprowadzić niemal od razu.</p>
                    <a href={'/mieszkania/szczegoly/32a293ec-3582-ee11-8179-000d3a2e47bc'} className='bg-primary button-primary max-w-full mt-8'>
                        Poznaj szczegóły
                    </a>
                </div>
            </div>
        </section>
    )
}